import { Box } from '@mui/material';
import { StepType } from './types';

const Step = ({ active, completed }: StepType) => {
  return active ? (
    <AnimatedStep />
  ) : completed ? (
    <Box height={6} width="100%" bgcolor="primary.main" borderRadius={4} />
  ) : (
    <Box height={6} width="100%" bgcolor="secondary.light" borderRadius={4} />
  );
};

const AnimatedStep = () => {
  return (
    <Box
      sx={{
        height: 6,
        width: '100%',
        backgroundColor: 'secondary.light',
        borderRadius: 0.5,
        position: 'relative',
        overflow: 'hidden',
        '&::after': {
          content: '""',
          position: 'absolute',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'primary.main',
          borderRadius: 0.5,
          animation: 'progressAnimation 1.5s infinite cubic-bezier(0.65, 0, 0.35, 1)',
          transform: 'translateX(-100%)',
        },
        '@keyframes progressAnimation': {
          '0%': {
            transform: 'translateX(-100%)',
          },
          '100%': {
            transform: 'translateX(100%)',
          },
        },
      }}
    />
  );
};

export default Step;
